import type { TranslationKey } from '@/lib/i18n';

export const TOAST_ACCESSIBILITY_VIEWPORT = [
  'common:toast.notifications',
  'Notifications',
] as const satisfies TranslationKey;
